import * as React from "react";
import * as ReactDOM from "react-dom";
import { Analytics } from "./Analytics";
import PinUnlockActivity from "./components/PinUnlockScreen/PinUnlockActivity";
import SetPinActivity from "./components/SetPinActivity";
import { setLocalStorageItem } from "./storage_utils";
import { setStatusBarAsBlackOnWhite } from "./utils/statusBar";

export const PIN_CODE_KEY = "medflyt_app_pin";
export const PIN_CODE_KEY_OVERRIDE = "medflyt_app_pin_override";

export class PinUnlockOverlayManager {
  constructor(
    private pinCode: string | null,
    private forgotPinCallback: () => void,
    private onInvalidPinCodeEntered: () => void
  ) {}

  public setCorrectPinCode(pinCode: string) {
    this.pinCode = pinCode;
  }

  public handleFirstTime() {
    if (this.pinCode === "FIRST_TIME") {
      this.pinCode = null;
    }
  }

  public showLockScreen(): void {
    if (this.elem !== null || this.pinCode === "FIRST_TIME") {
      return;
    }

    const lockEvent = new CustomEvent<{}>("pinLockEvent");
    // This event is so that the system doesn't update the dom in the background, currently used only in: MainScreen
    document.dispatchEvent(lockEvent);

    this.elem = document.createElement("div");
    this.elem.style.position = "absolute";
    this.elem.style.top = "0px";
    this.elem.style.width = "100%";
    this.elem.style.height = "100%";
    this.elem.style.overflow = "hidden";

    // Please see the document CSS-z-index.md
    this.elem.style.zIndex = "10003";

    document.body.appendChild(this.elem);

    const elem = this.elem;
    const unlockEvent = new CustomEvent<{}>("pinOnUnlockEvent");

    if (this.pinCode === null) {
      ReactDOM.render(
        React.createElement(SetPinActivity, {
          key: "set-pin-screen",
          onDone: (pin: string) => {
            ReactDOM.unmountComponentAtNode(elem);
            document.body.removeChild(elem);
            this.elem = null;

            setStatusBarAsBlackOnWhite();

            setTimeout(() => document.dispatchEvent(unlockEvent), 100);
            setLocalStorageItem(PIN_CODE_KEY, pin);
            this.pinCode = pin;
          },
        }),
        this.elem
      );
    } else {
      ReactDOM.render(
        React.createElement(PinUnlockActivity, {
          key: "pin-unlock-screen",
          correctPinCode: this.pinCode,
          onUnlocked: () => {
            ReactDOM.unmountComponentAtNode(elem);
            document.body.removeChild(elem);
            this.elem = null;

            setStatusBarAsBlackOnWhite();

            Analytics.track("Pin Screen Unlocked");

            // This event is so that the system doesn't update the dom in the background, currently used only in: MainScreen
            // The delay is used to prevent the pin screen from freezing because of request being done when loading mainscreen
            setTimeout(() => document.dispatchEvent(unlockEvent), 100);
          },
          onForgotPinClick: () => {
            Analytics.track("Forgot Pin Code Click");
            this.forgotPinCallback();
          },
          onInvalidPinCodeEntered: () => {
            Analytics.track("Invalid Pin Code Entered");
            this.onInvalidPinCodeEntered();
          },
        }),
        this.elem
      );
    }

    // TODO Proper handling of Back button. Probably make Back button immediately exit
  }

  private elem: HTMLElement | null = null;

  private closed = false;

  public close(): void {
    if (this.closed) {
      throw new Error("PinUnlockOverlayManager already closed");
    }
    this.closed = true;

    if (this.elem !== null) {
      document.body.removeChild(this.elem);
      this.elem = null;
    }
  }
}
